<template>
  <div :class="`idf-promotion-card--${type}`" class="idf-promotion-card" data-test-promotion-card>
    <slot name="media">
      <adn-image v-if="imageUrl" :source="imageUrl" alt="" class="idf-promotion-card__image" loading="eager" />
    </slot>

    <div class="idf-promotion-card__content">
      <h3>{{ title }}</h3>
      <p v-if="description">{{ description }}</p>
      <idf-component-link v-if="ctaLink && ctaLabel" :url="ctaLink" class="idf-promotion-card__cta">
        <adn-button>
          <span v-if="ctaIconName" :class="`adn-icon--${ctaIconName}`" class="adn-icon" />
          {{ ctaLabel }}
        </adn-button>
      </idf-component-link>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'

import AdnImage from '../AdnImage/AdnImage.vue'
import IdfComponentLink from '../IdfComponentLink/IdfComponentLink.vue'
import AdnButton from '../AdnButton/AdnButton.vue'

export default defineComponent({
  name: 'IdfPromotionCard',
  components: { AdnImage, IdfComponentLink, AdnButton },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: String,
    imageUrl: String,
    ctaLabel: String,
    ctaLink: String,
    ctaIconName: String,
    type: {
      type: String,
      validator: (value) => ['big', 'medium', 'small'].includes(value),
      default: 'big',
    },
  },
  setup() {
    return {}
  },
})
</script>
<style lang="scss">
.idf-promotion-card {
  background-color: var(--idf-promotion-card-background-color, var(--color-white));
  border: 1px solid var(--color-grey-light);
  border-radius: var(--border-radius-2);

  &__image {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    max-height: 36rem;
    object-fit: cover;
    object-position: center;
    width: 100%;
  }

  &__content {
    color: var(--idf-promotion-card-content-text-color, var(--color-black));
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);
    padding: var(--spacing-3);

    h3 {
      margin: 0;
    }
  }

  &__cta {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;

    .adn-button {
      align-items: center;
      display: flex;
      justify-content: center;
      background-color: var(--idf-promotion-card-cta-background-color, var(--color-blue));
    }
  }

  &.idf-promotion-card--medium .idf-promotion-card__image {
    max-height: 24rem;
  }

  &.idf-promotion-card--small .idf-promotion-card__image {
    max-height: 16rem;
  }
}

@media screen and (max-width: $breakpoint-xs) {
  .idf-promotion-card.idf-promotion-card--big,
  .idf-promotion-card.idf-promotion-card--medium,
  .idf-promotion-card.idf-promotion-card--small {
    .idf-promotion-card__image {
      max-height: 16rem;
    }
  }
}
</style>
